import { render, staticRenderFns, recyclableRender, components } from "./u-switch.vue?vue&type=template&id=3a8aa7a9&scoped=true&"
var renderjs
import script from "./u-switch.vue?vue&type=script&lang=js&"
export * from "./u-switch.vue?vue&type=script&lang=js&"
import style0 from "./u-switch.vue?vue&type=style&index=0&id=3a8aa7a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8aa7a9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-switch/u-switch.vue"
export default component.exports